import { memo } from "react";
import { Chip } from "react-native-paper";

import { useCopyToClipboard } from "../../useCopyToClipboard";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import { RecommendedChips } from "../ChatUI/RecommendedChips";
import { RecommendedChipsSkeleton } from "../ChatUI/RecommendedChipsSkeleton";
import { CustomListSubheader } from "../CustomListSubheader";

export type PostAnswerFollowUps = {
	visible?: boolean;
	loading?: boolean;
	queries: string[];
	onSelectQuery: (query: string) => void;
	title?: string;
	showCustomResponse?: boolean;
};

type PostAnswerFollowUpsBlockProps = {
	followUps?: PostAnswerFollowUps;
	itemId: number;
};

export const PostAnswerFollowUpsBlock = memo(
	({ followUps, itemId }: PostAnswerFollowUpsBlockProps) => {
		const { copyToClipboard } = useCopyToClipboard();
		const { isMobile } = useDevice();

		return (
			<Box gap={16} paddingHorizontal={isMobile ? 16 : 0}>
				{followUps?.visible ? (
					<Box>
						<CustomListSubheader
							enableGutters={false}
							textVariant="titleMedium"
							style={{
								paddingTop: isMobile ? 8 : 0,
								paddingBottom: 8,
							}}
						>
							{followUps.title ?? "Follow-ups"}
						</CustomListSubheader>
						{followUps.loading ? (
							<RecommendedChipsSkeleton numLines={4} />
						) : (
							<RecommendedChips
								queries={followUps.queries}
								handleSelectQuery={followUps.onSelectQuery}
								showCustomResponse={followUps.showCustomResponse}
								noFlatList
							/>
						)}
					</Box>
				) : null}
				{followUps?.visible ? (
					<Chip
						compact
						onPress={() =>
							copyToClipboard(
								`${itemId}`,
								`Item #${itemId} copied to clipboard`,
							)
						}
						style={{ alignSelf: "baseline" }}
					>
						Item: #{itemId}
					</Chip>
				) : null}
			</Box>
		);
	},
);
